import { CallAttemptsIcon } from '@forwardflow/assets/svg/CallAttemptsIcon'
import { useGetDashboardCommunication } from '@forwardflow/hooks/customHooks'
import { AgentType, TimePeriod } from '@forwardflow/types'
import { useSearchParams } from 'react-router-dom'

export const ContactRate = () => {
   const [searchParams] = useSearchParams()
   const timePeriod = searchParams.get('timePeriod') || 'allTime'
   const agentType = searchParams.get('agentType') || 'all'
   const {
      data: DashboardChartsLeadSource,
      isLoading: DashboardChartsLeadSourceLoading,
   } = useGetDashboardCommunication({
      timePeriod: timePeriod as TimePeriod,
      agentType: agentType as AgentType,
   })

   const contactRate = DashboardChartsLeadSource?.contactRate

   const getChangeText = (change: { value: number; isIncrement: boolean }) => {
      const sign = change.isIncrement ? '+' : '-'
      const color = change.isIncrement ? '#00AB40' : '#FF5185'
      return (
         <span className={`text-sm font-semibold`} style={{ color }}>
            {sign}
            {change.value}%
         </span>
      )
   }

   if (DashboardChartsLeadSourceLoading) {
      return (
         <div className="flex flex-col items-center justify-center w-full h-full p-6 text-white shadow-lg bg-white/5 rounded-xl">
            <span className="font-medium">Loading Contact Rate...</span>
         </div>
      )
   }

   return (
      <div className="flex flex-col justify-center w-full h-full px-6 py-4 text-white shadow-lg bg-white/5 rounded-xl">
         {/* <div className="flex items-center gap-6 mb-auto h-14">
            <CallAttemptsIcon />
            <span className="font-medium">Contact Rate</span>
         </div> */}
         <div className="flex items-center justify-between">
            <div className="flex flex-col justify-between flex-1 py-5 border-r border-white/20">
               <div className="flex items-center gap-2 mt-1">
                  <div className="mr-6 scale-90">
                     <CallAttemptsIcon />
                  </div>
                  {/* <span className="text-base">Overall</span> */}
                  <div className="flex items-baseline gap-2 mt-1">
                     <span className="text-2xl font-medium">
                        {contactRate?.overall?.percentage ?? '--'}% Contact Rate
                     </span>
                     {contactRate?.overall?.change &&
                        getChangeText(contactRate.overall.change)}
                  </div>
               </div>
            </div>
            <span className="w-[30%] text-right text-white/70">
               {contactRate?.overall?.conversations ?? '--'} Conversion
            </span>
         </div>
         {/* <hr className="my-3 border-t border-white/20" />
         <div className="flex flex-col gap-2">
            <div className="flex items-center justify-between">
               <span className="text-base">New Leads</span>
               <div className="flex items-center gap-2">
                  <span className="font-semibold">
                     {contactRate?.newLeads?.percentage ?? '--'}%
                  </span>
                  {contactRate?.newLeads?.change &&
                     getChangeText(contactRate.newLeads.change)}
               </div>
            </div>
            <hr className="my-3 border-t border-white/20" />
            <div className="flex items-center justify-between">
               <span className="text-base">Revive leads</span>
               <div className="flex items-center gap-2">
                  <span className="font-semibold">
                     {contactRate?.reviveLeads?.percentage ?? '--'}%
                  </span>
                  {contactRate?.reviveLeads?.change &&
                     getChangeText(contactRate.reviveLeads.change)}
               </div>
            </div>
         </div> */}
      </div>
   )
}
